if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        if (!this.form) return;

        this.variantIdInput = this.form.querySelector('[name="id"]');
        if (this.variantIdInput) this.variantIdInput.disabled = false;

        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton?.querySelector('span');
        this.spinner = this.querySelector('.loading__spinner');
        this.cart =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer');
        this.hideErrors = this.dataset.hideErrors === 'true';

        if (document.querySelector('cart-drawer') && this.submitButton) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }

        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }

      async onSubmitHandler(event) {
        event.preventDefault();

        if (!this.submitButton || this.submitButton.getAttribute('aria-disabled') === 'true') {
          return;
        }

        this.handleErrorMessage();
        this.setLoading(true);

        const formData = new FormData(this.form);
        const variantId = formData.get('id');
        const quantity = Number.parseInt(formData.get('quantity'), 10) || 1;

        if (!variantId) {
          this.handleErrorMessage('Please choose an available option.');
          this.setLoading(false);
          return;
        }

        if (
          this.cart &&
          typeof this.cart.getSectionsToRender === 'function'
        ) {
          formData.append(
            'sections',
            this.cart
              .getSectionsToRender()
              .map((section) => section.id)
              .join(',')
          );
          formData.append('sections_url', window.location.pathname);

          if (typeof this.cart.setActiveElement === 'function') {
            this.cart.setActiveElement(document.activeElement);
          }
        }

        try {
          const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
            },
            body: formData,
          });

          const result = await response.json();

          if (!response.ok || result.status) {
            throw new Error(
              result.description || result.message || 'Unable to add this item.'
            );
          }

          if (
            typeof publish === 'function' &&
            window.PUB_SUB_EVENTS?.cartUpdate
          ) {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              productVariantId: variantId,
              cartData: result,
            });
          }

          if (this.cart && typeof this.cart.renderContents === 'function') {
            this.cart.renderContents(result);
          } else {
            await this.refreshCartIcon();
          }

          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal && typeof quickAddModal.hide === 'function') {
            quickAddModal.hide(true);
          }

          document.dispatchEvent(
            new CustomEvent('sc:cart-added', {
              bubbles: true,
              detail: {
                variantId,
                quantity,
                item: result,
              },
            })
          );
        } catch (error) {
          console.error('Add to cart failed:', error);
          this.handleErrorMessage(error.message || 'Unable to add this item.');
        } finally {
          this.setLoading(false);
        }
      }

      setLoading(isLoading) {
        if (!this.submitButton) return;

        if (isLoading) {
          this.submitButton.setAttribute('aria-disabled', 'true');
          this.submitButton.classList.add('loading');
          this.spinner?.classList.remove('hidden');
        } else {
          this.submitButton.removeAttribute('aria-disabled');
          this.submitButton.classList.remove('loading');
          this.spinner?.classList.add('hidden');
        }
      }

      async refreshCartIcon() {
        try {
          const response = await fetch(
            `${window.routes?.cart_url || '/cart'}?section_id=cart-icon-bubble`
          );
          const html = await response.text();
          const parsed = new DOMParser().parseFromString(html, 'text/html');
          const nextBubble = parsed.querySelector('#shopify-section-cart-icon-bubble');
          const currentBubble = document.querySelector('#shopify-section-cart-icon-bubble');

          if (nextBubble && currentBubble) {
            currentBubble.innerHTML = nextBubble.innerHTML;
          }
        } catch (error) {
          console.error('Cart count refresh failed:', error);
        }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector('.product-form__error-message-wrapper');

        if (!this.errorMessageWrapper) return;

        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage && this.errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (!this.submitButton) return;

        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text && this.submitButtonText) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          if (this.submitButtonText) {
            this.submitButtonText.textContent = window.variantStrings?.addToCart || 'Add to cart';
          }
        }
      }
    }
  );
}
